//#region IMPORT
import React, { useState, useEffect } from 'react';
import M_WOS_BASIC_02 from './M_WOS_BASIC_02';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import { WorkingCheckActions } from '../../../Reducer/WorkingCheckReducer';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import useFcmHandler from '../../../Hooks/useFcmHandler';
import dayjs from 'dayjs';
import { useSearch1, useSave1 } from './M_WOS_BASIC_02_Query';
import { useSave } from '../../../Hooks/useSave';
import useFileUpload from '../../../Hooks/useFileUpload';
import { WOS_BASIC_02_Schema } from './M_WOS_BASIC_02_Schema';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import { useBackStack } from '../../../Hooks/back/useBackStack';
//#endregion

const INPUTS = {
  workStopCd: '',
  solveYn: '',
  solveId: '',
  solveComment: '',
  solveImagePath: '',
  skipYn: '',
  userId: '',
};

function M_WOS_BASIC_02F() {
  //#region 변수
  const { id } = useParams();
  const dispatch = useDispatch();
  const { navigate } = useAppNavigate();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const [rowData1, setRowData1] = useState({});
  const [stopImageList, setStopImageList] = useState([]);
  const [solveImageList, setSolveImageList] = useState([]);
  const [errors, setErrors] = useState({});
  const [workStopInputs, setWorkStopInputs] = useState(INPUTS);
  const [memberList, setMemberList] = useState([]);
  const sendFcm = useFcmHandler();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const ToggleDrawer = (anchor, open) => (e) => {
    dispatch(
      BottomSheetActions.SetBottomSheetState({
        bottom: open,
        type: open ? 'signWorkStop' : bottomSheetState?.type,
      })
    );
  };
  const workStopUpload = useFileUpload({
    oldFilePathField: 'image',
    newFileNameField: 'saveName',
    getTargetPath: () =>
      `WorkStop/${rowData1.workStopCustCd}/WOS_BASIC_01/${rowData1.depCd}`,
  });
  //#endregion

  useEffect(() => {
    Init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const Init = () => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('작업 내역'));
    Search1Async({ workStopCd: id });
  };

  //#region 쿼리
  const { runAsync: Search1Async } = useSearch1({
    onSuccess: (rows) => {
      if (!rows || rows.length === 0) {
        setRowData1({});
        setStopImageList([]);
        setSolveImageList([]);
        setMemberList([]);
        return;
      }
      if (rows[0]?.type === 'Error') {
        dispatch(showSnackbar({ message: rows[0].message, type: 'error' }));
        return;
      }
      const first = rows[0];
      setRowData1(first);
      setMemberList(rows.map((r) => r.stopId).filter(Boolean));

      setStopImageList(
        first?.stopImagePath
          ? first.stopImagePath.split(',').map((u) => u.trim())
          : []
      );
      setSolveImageList(
        first?.solveImagePath
          ? first.solveImagePath.split(',').map((u) => u.trim())
          : []
      );
    },
  });

  const { runAsync: Save1Async } = useSave1();

  const { run: Save1 } = useSave({
    menuId: 'M_WOS_BASIC_02',
    schema: WOS_BASIC_02_Schema,
    fileSave: async () => {
      const solveImagePath = await workStopUpload.SaveLogicFile();
      return { solveImagePath: solveImagePath || '' };
    },
    saveData: (param) => ({
      workStopCd: id,
      solveYn: param?.solveYn ?? workStopInputs.solveYn,
      solveId: userInfo.userid,
      solveComment: workStopInputs.solveComment,
      solveImagePath: param?.solveImagePath || '',
      skipYn: param?.skipYn ?? workStopInputs.skipYn ?? '',
      userId: param?.userId || userInfo.userid,
    }),
    requestSave: async (rows) => {
      const res = await Save1Async({
        row: rows[0],
        userInfo,
      });
      setWorkStopInputs((prev) => ({ ...prev, solveComment: '' }));
      workStopUpload.setPreviewList([]);
      dispatch(WorkingCheckActions.setStopWorking(0));
      dispatch(WorkingCheckActions.setWorkStopCd(id));
      await Search1Async({ workStopCd: id });
      return res;
    },
    onSuccess: async ({ saveDetailData, requestRows }) => {
      for (const stopId of memberList) {
        await sendFcm({
          targetUserId: stopId,
          requestUserId: userInfo.userid,
          body: `${userInfo.userNm}님이 작업 재개를 승인했습니다.`,
          status: '작업재개',
          codeGroup: 'AL_006_002',
          title: '작업중지',
          route: '/M_WorkStop',
          responseData: requestRows[0].workStopCd,
        });
      }
    },
  });
  //#endregion

  const DeletePreview = async (fileItem) => {
    try {
      const payload = {
        oldFilePath: fileItem.image || fileItem.previewFilePath,
        sourcePreviewPath: '',
        newFileName: '',
        targetPath: '',
      };
      const { data } = await Commons.Axios(
        'post1',
        Global.file.useUrl + Global.urls.Execute.moveAndReplaceFile,
        payload
      );
      if (!data || data.type === 'Error') {
        throw new Error(data?.message || '파일 삭제 실패');
      }
      workStopUpload.setPreviewList((prev) =>
        prev.map((img) => (img === fileItem ? { ...img, deleted: true } : img))
      );
    } catch (e) {
      console.error(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  const SaveLogicPreview = async (_file) => {
    try {
      const formList = new FormData();
      formList.append('UserId', userInfo.userid);
      formList.append('FilePath', 'PreviewFiles');
      formList.append('FormFile', _file);
      const result = await Commons.Axios(
        'file2',
        Global.file.useUrl + Global.urls.Execute.videoUpload,
        null,
        formList
      );
      let finalSavePath = result?.data?.filePath || '';
      if (finalSavePath.includes('PreviewFiles')) {
        finalSavePath = finalSavePath.substring(
          finalSavePath.indexOf('PreviewFiles')
        );
      }
      return finalSavePath.replace(/\\/g, '/');
    } catch (e) {
      console.error('SaveLogicPreview Error:', e);
      return '';
    }
  };

  const FileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const timestamp = dayjs().format('YYYYMMDDHHmmss');
    const saveName = `${timestamp}_${file.name}`;
    const fileToSave = new File([file], saveName, { type: file.type });
    const previewPath = await SaveLogicPreview(fileToSave);
    const previewUrl = Global.file.useUrl + 'files/' + previewPath;
    workStopUpload.setPreviewList((prev) => [
      ...prev,
      {
        workStopCd: '',
        fileName: file.name,
        fileType: file.type,
        preview: previewUrl,
        previewFilePath: previewPath,
        saveName: saveName,
        image: '',
      },
    ]);
    event.target.value = '';
  };

  const ValidateAll = () => {
    const requiredFields = ['stopComment'];
    const fieldLabels = { stopComment: '조치 내용' };
    let newErrors = {};
    let hasError = false;
    requiredFields.forEach((field) => {
      const msg =
        (workStopInputs[field] || '').trim() === ''
          ? `${fieldLabels[field]}을(를) 입력하세요.`
          : '';
      newErrors[field] = msg;
      if (msg) hasError = true;
    });
    setErrors(newErrors);
    return !hasError;
  };

  const SaveLogic1 = (override) => Save1(override);

  return (
    <div className="wrap">
      <M_WOS_BASIC_02
        id={id}
        userInfo={userInfo}
        rowData1={rowData1}
        stopImageList={stopImageList}
        solveImageList={solveImageList}
        workStopUpload={{
          ...workStopUpload,
          FileChange,
          DeletePreview,
        }}
        SaveLogic1={SaveLogic1}
        ValidateAll={ValidateAll}
        setWorkStopInputs={setWorkStopInputs}
        workStopInputs={workStopInputs}
        errors={errors}
        setErrors={setErrors}
        ToggleDrawer={ToggleDrawer}
      />
    </div>
  );
}

export default M_WOS_BASIC_02F;
